export const ARCTIC_BLUE = "#27A4BF";
export const BRIGHT_PURPLE = "#896CA5";
export const GRAY_300 = "#D8D8D8";
export const HAVELOCK_BLUE = "#3C8BD2";
export const SUSHI = "#9AC448";
